import styled from "styled-components";
import { Select } from "antd";

export const StyleSelect = styled(Select)`
  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 5px !important; 
  }
`;